import {Injectable} from '@angular/core';

const TEMPERATURE_TYPE = 'pt_v5';
const CHARACTERS_LIMIT = 100;

interface ISelectedElements {
  locations: {
    temperature: ILocation[],
    others: ILocation[]
  };
  groups: IGroup[];
}

interface IGroup {
  id: number;
  name: string;
  fullySelected: false;
}

interface ILocation {
  id: number;
  name: string;
  groupId?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ExportFileNameService {

  getName(locations, projectName) {

    const isGroup = (location) => location.child && location.child.length > 0;
    const selectedElements = this.selectedElementFactory();

    locations.forEach(
        (location) => {
          if (isGroup(location)) {
            const group = this.groupInstanceFactory(location.id, location.name);
            let hasAChildSelected: boolean;
            let hasAChildNotSelected: boolean;
            location.child.forEach(
                (child) => {
                  const results = this.analyzeLocation(child, location.id);
                  results.forEach(
                      (result) => {
                        if (result.selected) {
                          if ('temperature' === result.locationType) {
                            selectedElements.locations.temperature.push(result.location);
                          } else {
                            selectedElements.locations.others.push(result.location);
                            hasAChildSelected = true;
                          }
                        }
                        if (!result.selected && 'temperature' !== result.locationType) {
                          hasAChildNotSelected = true;
                        }
                      }
                  );
                }
            );
            if (hasAChildSelected) {
              if (!hasAChildNotSelected) {
                group.fullySelected = true;
              }
              selectedElements.groups.push(group);
            }
          } else {
            const results = this.analyzeLocation(location);
            results.forEach(
                (result) => {
                  if (result.selected) {
                    selectedElements.locations[result.locationType].push(result.location);
                  }
                }
            );
          }
        }
    );

    return this.computeName(selectedElements, projectName);
  }

  private analyzeLocation(location, groupId?):
      { location: ILocation, locationType: 'temperature' | 'others', selected: boolean }[] {

    const isTemperature = (loc) => TEMPERATURE_TYPE === loc.type;
    const areMultipleUnits = (loc) => loc.unit && loc.unit.length > 1;

    const results = [];

    if (areMultipleUnits(location)) {

      location.unit.forEach(
          (unit) => {
            const result: any = {
              location: this.locationInstanceFactory(location.id, location.name, groupId ? groupId : ''),
              locationType: unit.unit === 'TEMPERATURE' ? 'temperature' : 'others',
              selected: unit.selected
            };
            results.push(result);
          });
    } else {
      const result: any = {
        location: this.locationInstanceFactory(location.id, location.name, groupId ? groupId : ''),
        locationType: isTemperature(location) ? 'temperature' : 'others',
        selected: location.selected
      };
      results.push(result);
    }

    return results;
  }

  private computeName(selectedElements: ISelectedElements, projectName) {

    let name = projectName;

    if (1 === selectedElements.locations.others.length) {
      name += '-' + selectedElements.locations.others[0].name;
    }
    if (0 === selectedElements.locations.others.length && 1 === selectedElements.locations.temperature.length) {
      name += '-' + selectedElements.locations.temperature[0].name;
    }
    if (1 === selectedElements.groups.length && selectedElements.groups[0].fullySelected) {
      const group = selectedElements.groups[0];
      const selectedLocationsNotBelongingToGroup = selectedElements.locations.others.find(
          (location) => location.groupId !== group.id
      );
      if (!selectedLocationsNotBelongingToGroup) {
        name += '-' + group.name;
      }
    }

    const replaceInvalidCharacters: (string) => string = (string) => string.replace(/[ /\\?%*:|"<>]/g, '-');
    const removeDuplicateDashes: (string) => string = (string) => {
      let newString = '';
      const iterator = string[Symbol.iterator]();
      let theChar = iterator.next();
      let lastValue = '';
      while (!theChar.done) {
        if (!('-' === lastValue && '-' === theChar.value)) {
          newString += theChar.value;
        }
        lastValue = theChar.value;
        theChar = iterator.next();
      }
      return newString;
    };
    const formatString: (string) => string = (string) => removeDuplicateDashes(replaceInvalidCharacters(string));

    name = formatString(name);

    if (CHARACTERS_LIMIT < name.length) {
      name = formatString(projectName);
    }
    if (CHARACTERS_LIMIT < name.length) {
      name = name.substring(0, CHARACTERS_LIMIT - 1);
    }

    return name;
  }

  private selectedElementFactory() {
    return {
      locations: {
        temperature: [],
        others: []
      },
      groups: []
    };
  }

  private locationInstanceFactory(id: number, name: string, groupId?: number) {
    return {id, name, groupId};
  }

  private groupInstanceFactory(id: number, name: string, fullySelected = false) {
    return {id, name, fullySelected};
  }

}


